module.exports = __webpack_public_path__ + "static/media/redpacket.892ace1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon/redpacket.png
// module id = 578
// module chunks = 6